import { ICurrentDateRange, ICurrentEmployee, IStore } from 'store/types';
import { ICardSession, IForgotPasswordVerifyToken, IIdentity } from 'types';

export const selectIsTipCalcFormDirty = (state: IStore): boolean => state?.app?.isTipCalcFormDirty;
export const selectCardSession =
  () =>
  (state: IStore): ICardSession | null =>
    state?.app?.cardSession;
export const selectForgotPasswordIdentity =
  () =>
  (state: IStore): IIdentity | null =>
    state?.app?.forgotPasswordIdentity;
export const selectForgotPasswordVerifyToken =
  () =>
  (state: IStore): IForgotPasswordVerifyToken | null =>
    state?.app?.forgotPasswordVerifyToken;

export const selectCurrentEmployee =
  () =>
  (state: IStore): ICurrentEmployee =>
    state?.app?.currentEmployee;

export const selectCurrentDateRange =
  () =>
  (state: IStore): ICurrentDateRange =>
    state?.app?.currentDateRange;
